import { Box, Container, H5, Stack, Text } from '@amboss/design-system';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks/redux';
import useBottomModal from '../../../hooks/useBottomModal';
import useLoading from '../../../hooks/useLoading';
import { CreditType } from '../../../interfaces/credit';
import { creditsTypeSelector } from '../../../store/credits/creditsSlice';
import { selectUser } from '../../../store/profile/profileSlice';
import { totalCreditsSelector } from '../../../store/totalCredits/totalCreditsSlice';
import Loader from '../../atoms/Loader';
import BottomModal from '../../modals/BottomModal';
import Modal from '../../modals/Modal';
import CreditTabs from './tabs/CreditTabs';
import CreditTabsIpc from './tabs/CreditTabsIpc';

export const Credits = () => {
  const { t } = useTranslation();
  const { show } = useBottomModal();
  const { loading, setLoading } = useLoading();
  const user = useAppSelector(selectUser);
  const creditType = useAppSelector(creditsTypeSelector);
  const totalCredits = useAppSelector(totalCreditsSelector);
  const claimed = totalCredits[creditType].claimed;
  const tabs = creditType === CreditType.IPC ? <CreditTabsIpc /> : <CreditTabs />;

  useEffect(() => {
    setLoading(false);
  }, []);

  const getType = () => {
    return creditType === CreditType.IPC ? `ipc.${user.association}` : 'other';
  };
  return (
    <div style={{ marginBottom: show ? 150 : 0 }}>
      <Modal />
      <Container elevation={0}>
        {loading && <Loader />}

        {user?.clinicalRole && (
          <>
            <Box>
              <Stack space={'xs'}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <H5>{t(`home.cards.${creditType}.title`)}</H5>
                  <Text color={'tertiary'}>
                    <b style={{ color: 'black' }}>{claimed}</b>{' '}
                    {t(`home.labels.type.${getType()}.claimed`, { count: claimed })}
                  </Text>
                </div>
              </Stack>
            </Box>
            {tabs}
          </>
        )}
      </Container>
      <div id='callout-portal' style={{ marginTop: 30 }}></div>

      {show && <BottomModal />}
    </div>
  );
};
